const lightTheme = {
  title: 'light',
  colors: {
    backgroundColor: '#F5F5F5',
    textColor: '#1A1A1A',
    mainColor:
      'background: -webkit-linear-gradient(82deg, #00b8c8 0%, #00dcec 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent;',
    iconBackgroundColor:
      'transparent linear-gradient(76deg, #00b8c8 0%, #00dcec 100%) 0% 0% no-repeat padding-box;',
    buttonColor:
      'background: transparent -webkit-linear-gradient(82deg, #00b8c8 0%, #00dcec 100%) 0% 0% no-repeat padding-box;',
    inputColor: '#00b8c8',
    iconColor: '#1A1A1A',
    inputBackgroundColor: '#E8E8E8',
    inputTextColor: '#1A1A1A',
    footerBackgroundColor: '#E8E8E8',
    cardsBackgroundColor: '#FFFFFF',
    rightNavBackgroundColor: '#2A2A2A',
    xIconRightNavColor: '#ccc',
    hamburguerIconRightNavColor: '#1A1A1A',
    h5TextColor: '#555555',
    inputPlaceholderColor: '#999999',
    buttonHover: '#009aaa',
    iconHoverColor: '#00b8c8',
    tagBackgroundColor: '#E8E8E8',
  },
};

export default lightTheme;
